import { Injectable } from "@angular/core";
import { OrderService } from "./order-service";
import { MatDialogConfig, MatDialog } from "@angular/material";
import { Dbutils } from "./db-utils";
import { DeliveryComponent } from "src/app/core/delivery/delivery.component";
import { TakeawayComponent } from "src/app/core/takeaway/takeaway.component";
import * as _ from "lodash";
import { Router } from "@angular/router";
import { LoaderService } from "./loader-service";
import { MessageModalComponent } from "../components/message-modal/message-modal.component";

@Injectable({
  providedIn: "root",
})
export class OrderTypeService {
  constructor(
    private orderService: OrderService,
    private dialog: MatDialog,
    private Dbutils: Dbutils,
    private router: Router,
    private loader: LoaderService
  ) { }
  private customer;
  private branches = [];
  async ngOnInit() {
    const branches = await this.Dbutils.getBranches();
    this.branches = _.map(branches, (branch) => {
      return branch["branchName"];
    });
  }

  public chooseOrderType(orderType, navigiateAfterChoosen) {
    const avialable = this.checkIfOrderTypeAvailable(orderType);
    if (!avialable) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.data = `שירות ה ${orderType} לא זמין כעת, אנא נסה בשנית מאוחר יותר.`
      this.dialog.open(MessageModalComponent, { data: `שירות ה ${orderType} לא זמין כעת, אנא נסה בשנית מאוחר יותר.` });

      return;
    }
    setTimeout(() => {
      const dialogRef = this.dialog.open(MessageModalComponent, { data: `פג תוקף להזמנה...` });
      setTimeout(() => {
        dialogRef.close();
        this.router.navigate([""])
      }, 3000)
    }, 900000);
    if (orderType === "delivery") {
      this.chooseDeliveryOrderType(navigiateAfterChoosen);
    }
    if (orderType === "TA") {
      this.chooseTAOrderType(navigiateAfterChoosen);
    }
  }
  private async getBranches() {
    const branches = await this.Dbutils.getBranches();
    return _.map(branches, (branch) => {
      return branch["branchName"];
    });
  }
  private checkIfOrderTypeAvailable(orderType): boolean {
    const customer = this.loader.getCustomer();
    let now = new Date;
    let hour = now.getHours();
    if (orderType === "delivery") {
      return (customer.deliveryCloseTime > hour && customer.deliveryOpenTime < hour && customer.deliveryActive)
    }
    if (orderType === "TA") {
      return (customer.taActive)
    }
  }

  private async chooseDeliveryOrderType(navigiateAfterChoosen: boolean) {

    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = await this.getBranches();
    dialogConfig.maxWidth = "100vw !important";
    const dialogRef = this.dialog.open(DeliveryComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (_.isNil(result)) {
        return;
      }
      if (result.ta) {
        this.chooseTAOrderType(navigiateAfterChoosen);
        return;
      }
      if (result.branch) {
        this.orderService.setOrder({
          branch: result.branch.branchName,
          deliveryFee: result.branch.deliveryFee,
          orderType: "delivery",
          street: result.street,
          city: result.city,
          homeNum: result.houseNumber,
          floor: result.floor,
          address:
            result.street +
            " " +
            result.houseNumber +
            "," +
            result.city +
            ", קומה: " +
            result.floor,
        });
        if (navigiateAfterChoosen) {
          this.router.navigate(["all-products"]);
        }
      }
    });
  }

  private async chooseTAOrderType(navigiateAfterChoosen: boolean) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.data = await this.getBranches();
    dialogConfig.maxWidth = "100vw !important";
    const dialogRef = this.dialog.open(TakeawayComponent, dialogConfig);
    dialogRef.afterClosed().subscribe((result) => {
      if (_.isNil(result)) {
        return;
      }
      if (result.delivery) {
        this.chooseDeliveryOrderType(navigiateAfterChoosen);
        return;
      }
      if (result.branch) {
        // { "branch": this.selectedBranch, "now": this.now, "hour": this.selectedHour }
        this.orderService.setOrder({
          branch: result.branch,
          orderType: "TA",
          date: result.hour,
          street: null,
          city: null,
          homeNumber: null,
          floor: null,
          address: null,
        });
      }
      if (navigiateAfterChoosen) {
        this.router.navigate(["all-products"]);
      }
    });
  }
}
